/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { service } from "@ember/service";
import Component from "@glimmer/component";
import { restartableTask, timeout } from "ember-concurrency";
import type FetcherService from "parog-web/services/fetcher";
import { apiFieldset } from "parog-web/utils/api-fieldset";

import styles from "./component.module.css";

export default class PatientSearchComponent extends Component {
  styles = styles;

  @service declare fetcher: FetcherService;

  queryPatients = restartableTask(async (event: Event) => {
    const query = (event.target as HTMLInputElement).value;
    if (query.length < 1) return [];

    // Bounce search
    await timeout(400);

    // Don't make a request if the query is just whitespace
    if (query.trim().length === 0) {
      return [];
    }
    const patients = await this.fetcher.loadRecords("patient", {
      filter: { query: query },
      fields: apiFieldset("patient", ["firstName", "lastName", "birthName"])
    });

    return patients;
  });
}
